import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FnolRequest } from "../../../models";
import { Router } from "@angular/router";
import { diagnosisCategories } from "../../../services/diagnosis-category";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'cpf-fnol-request-details',
  templateUrl: './fnol-request-details.component.html',
  styleUrls: ['./fnol-request-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FnolRequestDetailsComponent {
  @Input() fnolRequest!: FnolRequest;
  @Input() showBackButton = true;

  constructor(
    private router: Router,
    private translate: TranslateService,
  ) {
  }

  findDiagnosisById(id: string, category: string) {
    return diagnosisCategories.find(diagnosis => diagnosis.name === category)?.values.find(diagnosis => diagnosis.id === id);
  }

  findCategoryById(id: string) {
    return diagnosisCategories.find(diagnosis => diagnosis.name === id);
  }

  getTranslatedCategory(categoryId: string) {
    let category = this.findCategoryById(categoryId);
    if (!category) {
      return "";
    }
    const lang = this.translate.getCurrentLang() ?? '';
    if (category.translations.hasOwnProperty(lang)) {
      // @ts-ignore
      return category.translations[lang];
    }
    return category.translations.de;
  }

  getTranslatedDiagnose(id: string, category: string) {
    let diagnose = this.findDiagnosisById(id, category);
    if (!diagnose) {
      return "";
    }
    const lang = this.translate.getCurrentLang() ?? '';
    if (diagnose.translations.hasOwnProperty(lang)) {
      // @ts-ignore
      return diagnose.translations[lang];
    }
    return diagnose.translations.de;
  }

  navigateBack() {
    this.router.navigate(['calingo', 'pet', 'claims']);
  }
}
